import { HeartHandshake, MessageCircleQuestion } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

export function ArguingDialog() {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button
          type="button"
          data-testid="arguing-info-button"
          className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm border border-[#C4A265]/50 text-[#8a6d3a] hover:bg-[#C4A265]/10 transition-all shrink-0"
        >
          <MessageCircleQuestion className="h-4 w-4" strokeWidth={1.75} /> Not loving these ideas?
        </button>
      </DialogTrigger>
      <DialogContent className="bg-[#FDFBF7] border-[#E8E3D9] max-w-lg" data-testid="arguing-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl text-[#2D2A26] flex items-center gap-2.5">
            <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#F5F2EA]">
              <HeartHandshake className="h-4 w-4 text-[#4A5D4E]" strokeWidth={1.5} />
            </span>
            Not loving these ideas?
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 text-[#2D2A26] leading-relaxed text-sm">
          <p>
            If one of you is hoping this will simply produce the exact solution you already had in mind,
            it might feel frustrating — and that's okay.
          </p>
          <p>
            That's not quite the point. The goal is to find ways forward that meet what you
            <em> both</em> care about deep down — not to declare a winner.
          </p>
          <div className="rounded-xl bg-[#F5F2EA] border border-[#E8E3D9] p-4">
            <p>
              If a suggestion doesn't sit right, it usually means one of your needs isn't being met yet.
              Name that need together, add it in, and let's find something that works for both of you.
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
